<template>
    <div>
        <div class="sidebar">
            <ul class="sidebar-list">
                <li v-has-role="['owner', 'manager']" :class="{ 'active': path === '/organization/stats' }">
                    <router-link to="/organization/stats" class="customers">
                        <user-image></user-image>
                        <span class="label">{{ $t('label.stats') }}</span>
                    </router-link>
                </li>
                <li v-has-role="['owner', 'manager']" v-for="employee in employees" :class="{ 'active': path === '/organization/stats/employee/' + employee.id }">
                    <router-link :to="'/organization/stats/employee/' + employee.id" class="customers">
                        <user-image :image="employee.image" :color="employee.color"></user-image>
                        <span class="label">{{ employee.name }}</span>
                    </router-link>
                </li>
            </ul>
        </div>
        <main class="main with-sidebar">
            <transition name="fade">
                <router-view :employees="employees" :statistics="statistics" :from="from" :to="to" :visible="visible" @rangeChanged="updateRange"></router-view>
            </transition>
        </main>
    </div>
</template>

<script>
  import UserImage from '@/components/widgets/UserImageWidget'
  export default {
    name: 'StatsPage',
    components: {UserImage},
    created () {
      this.getStats()
    },
    data () {
      return {
        employees: [],
        statistics: [],
        from: this.$moment().subtract(1, 'months').format('YYYY-MM-DD'),
        to: this.$moment().format('YYYY-MM-DD'),
        path: this.$route.fullPath,
        visible: false
      }
    },
    methods: {
      getStats () {
        this.$api.get('/v1/organizations/statistics?from=' + this.from + '&to=' + this.to).then(response => {
          this.employees = response.data.data.employees
          this.statistics = response.data.data.statistics
          this.visible = true
        })
      },
      updateRange (value) {
        this.from = this.$moment(value[0]).format('YYYY-MM-DD')
        this.to = this.$moment(value[1]).format('YYYY-MM-DD')
        this.getStats()
      }
    },
    watch: {
      '$route.fullPath': function (path) {
        this.path = path
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/Organization/Stats/Stats.vue